const module = {
  routes: [
    {
      path: '/payments',
      component: () => import('@/modules/payments/pages/index.vue'),
      children: [],
      meta: {
        layout: 'default',
        requiresAuth: true
      }
    }
  ]
};

export default module;
